import axios from "axios";
import BASE_URL from "../../assets/global/url";

// Posted, non-deleted cutoffs (newest first)
export const getCutoffs = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/earnings/getCutoffs`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
